/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AI Interview API
 * OpenAPI spec version: 1.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminInterviewDetail,
  AllowlistItem,
  DeleteTemplate200,
  ErrorResponse,
  ListAdminAllowlist200,
  ListAdminInterviews200,
  ListTemplates200,
  OkResponse,
  Template,
  TemplateInput,
  UpsertAdminAllowlistEntryBody
} from '../../types';

import { customFetch } from '../../../lib/fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type listAdminAllowlistResponse200 = {
  data: ListAdminAllowlist200
  status: 200
}
    
export type listAdminAllowlistResponseSuccess = (listAdminAllowlistResponse200) & {
  headers: Headers;
};
;

export type listAdminAllowlistResponse = (listAdminAllowlistResponseSuccess)

export const getListAdminAllowlistUrl = () => {


  

  return `/api/v1/admin/allowlist`
}

export const listAdminAllowlist = async ( options?: RequestInit): Promise<listAdminAllowlistResponse> => {
  
  return customFetch<listAdminAllowlistResponse>(getListAdminAllowlistUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getListAdminAllowlistInfiniteQueryKey = () => {
    return [
    'infinite', `/api/v1/admin/allowlist`
    ] as const;
    }

export const getListAdminAllowlistQueryKey = () => {
    return [
    `/api/v1/admin/allowlist`
    ] as const;
    }

    
export const getListAdminAllowlistInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listAdminAllowlist>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listAdminAllowlist>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminAllowlistInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminAllowlist>>> = ({ signal }) => listAdminAllowlist({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listAdminAllowlist>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListAdminAllowlistInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminAllowlist>>>
export type ListAdminAllowlistInfiniteQueryError = unknown


export function useListAdminAllowlistInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listAdminAllowlist>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listAdminAllowlist>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminAllowlist>>,
          TError,
          Awaited<ReturnType<typeof listAdminAllowlist>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListAdminAllowlistInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listAdminAllowlist>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listAdminAllowlist>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminAllowlist>>,
          TError,
          Awaited<ReturnType<typeof listAdminAllowlist>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListAdminAllowlistInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listAdminAllowlist>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listAdminAllowlist>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useListAdminAllowlistInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listAdminAllowlist>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listAdminAllowlist>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListAdminAllowlistInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchListAdminAllowlistInfiniteQuery = async <TData = Awaited<ReturnType<typeof listAdminAllowlist>>, TError = unknown>(
 queryClient: QueryClient,  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listAdminAllowlist>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListAdminAllowlistInfiniteQueryOptions(options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getListAdminAllowlistQueryOptions = <TData = Awaited<ReturnType<typeof listAdminAllowlist>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminAllowlist>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminAllowlistQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminAllowlist>>> = ({ signal }) => listAdminAllowlist({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminAllowlist>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListAdminAllowlistQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminAllowlist>>>
export type ListAdminAllowlistQueryError = unknown


export function useListAdminAllowlist<TData = Awaited<ReturnType<typeof listAdminAllowlist>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminAllowlist>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminAllowlist>>,
          TError,
          Awaited<ReturnType<typeof listAdminAllowlist>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListAdminAllowlist<TData = Awaited<ReturnType<typeof listAdminAllowlist>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminAllowlist>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminAllowlist>>,
          TError,
          Awaited<ReturnType<typeof listAdminAllowlist>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListAdminAllowlist<TData = Awaited<ReturnType<typeof listAdminAllowlist>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminAllowlist>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useListAdminAllowlist<TData = Awaited<ReturnType<typeof listAdminAllowlist>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminAllowlist>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListAdminAllowlistQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchListAdminAllowlistQuery = async <TData = Awaited<ReturnType<typeof listAdminAllowlist>>, TError = unknown>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminAllowlist>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListAdminAllowlistQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export type upsertAdminAllowlistEntryResponse200 = {
  data: AllowlistItem
  status: 200
}
    
export type upsertAdminAllowlistEntryResponseSuccess = (upsertAdminAllowlistEntryResponse200) & {
  headers: Headers;
};
;

export type upsertAdminAllowlistEntryResponse = (upsertAdminAllowlistEntryResponseSuccess)

export const getUpsertAdminAllowlistEntryUrl = () => {


  

  return `/api/v1/admin/allowlist`
}

export const upsertAdminAllowlistEntry = async (upsertAdminAllowlistEntryBody: UpsertAdminAllowlistEntryBody, options?: RequestInit): Promise<upsertAdminAllowlistEntryResponse> => {
  
  return customFetch<upsertAdminAllowlistEntryResponse>(getUpsertAdminAllowlistEntryUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertAdminAllowlistEntryBody,)
  }
);}




export const getUpsertAdminAllowlistEntryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertAdminAllowlistEntry>>, TError,{data: UpsertAdminAllowlistEntryBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertAdminAllowlistEntry>>, TError,{data: UpsertAdminAllowlistEntryBody}, TContext> => {

const mutationKey = ['upsertAdminAllowlistEntry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertAdminAllowlistEntry>>, {data: UpsertAdminAllowlistEntryBody}> = (props) => {
          const {data} = props ?? {};

          return  upsertAdminAllowlistEntry(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpsertAdminAllowlistEntryMutationResult = NonNullable<Awaited<ReturnType<typeof upsertAdminAllowlistEntry>>>
    export type UpsertAdminAllowlistEntryMutationBody = UpsertAdminAllowlistEntryBody
    export type UpsertAdminAllowlistEntryMutationError = unknown

    export const useUpsertAdminAllowlistEntry = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertAdminAllowlistEntry>>, TError,{data: UpsertAdminAllowlistEntryBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof upsertAdminAllowlistEntry>>,
        TError,
        {data: UpsertAdminAllowlistEntryBody},
        TContext
      > => {

      const mutationOptions = getUpsertAdminAllowlistEntryMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type deleteAdminAllowlistEntryResponse200 = {
  data: OkResponse
  status: 200
}
    
export type deleteAdminAllowlistEntryResponseSuccess = (deleteAdminAllowlistEntryResponse200) & {
  headers: Headers;
};
;

export type deleteAdminAllowlistEntryResponse = (deleteAdminAllowlistEntryResponseSuccess)

export const getDeleteAdminAllowlistEntryUrl = (email: string,) => {


  

  return `/api/v1/admin/allowlist/${email}`
}

export const deleteAdminAllowlistEntry = async (email: string, options?: RequestInit): Promise<deleteAdminAllowlistEntryResponse> => {
  
  return customFetch<deleteAdminAllowlistEntryResponse>(getDeleteAdminAllowlistEntryUrl(email),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getDeleteAdminAllowlistEntryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminAllowlistEntry>>, TError,{email: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminAllowlistEntry>>, TError,{email: string}, TContext> => {

const mutationKey = ['deleteAdminAllowlistEntry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminAllowlistEntry>>, {email: string}> = (props) => {
          const {email} = props ?? {};

          return  deleteAdminAllowlistEntry(email,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminAllowlistEntryMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminAllowlistEntry>>>
    
    export type DeleteAdminAllowlistEntryMutationError = unknown

    export const useDeleteAdminAllowlistEntry = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminAllowlistEntry>>, TError,{email: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAdminAllowlistEntry>>,
        TError,
        {email: string},
        TContext
      > => {

      const mutationOptions = getDeleteAdminAllowlistEntryMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type listTemplatesResponse200 = {
  data: ListTemplates200
  status: 200
}
    
export type listTemplatesResponseSuccess = (listTemplatesResponse200) & {
  headers: Headers;
};
;

export type listTemplatesResponse = (listTemplatesResponseSuccess)

export const getListTemplatesUrl = () => {


  

  return `/api/v1/admin/templates`
}

export const listTemplates = async ( options?: RequestInit): Promise<listTemplatesResponse> => {
  
  return customFetch<listTemplatesResponse>(getListTemplatesUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getListTemplatesInfiniteQueryKey = () => {
    return [
    'infinite', `/api/v1/admin/templates`
    ] as const;
    }

export const getListTemplatesQueryKey = () => {
    return [
    `/api/v1/admin/templates`
    ] as const;
    }

    
export const getListTemplatesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listTemplates>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTemplatesInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTemplates>>> = ({ signal }) => listTemplates({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListTemplatesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listTemplates>>>
export type ListTemplatesInfiniteQueryError = unknown


export function useListTemplatesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listTemplates>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTemplates>>,
          TError,
          Awaited<ReturnType<typeof listTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListTemplatesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listTemplates>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTemplates>>,
          TError,
          Awaited<ReturnType<typeof listTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListTemplatesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listTemplates>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useListTemplatesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listTemplates>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListTemplatesInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchListTemplatesInfiniteQuery = async <TData = Awaited<ReturnType<typeof listTemplates>>, TError = unknown>(
 queryClient: QueryClient,  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListTemplatesInfiniteQueryOptions(options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getListTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof listTemplates>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTemplatesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTemplates>>> = ({ signal }) => listTemplates({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof listTemplates>>>
export type ListTemplatesQueryError = unknown


export function useListTemplates<TData = Awaited<ReturnType<typeof listTemplates>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTemplates>>,
          TError,
          Awaited<ReturnType<typeof listTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListTemplates<TData = Awaited<ReturnType<typeof listTemplates>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTemplates>>,
          TError,
          Awaited<ReturnType<typeof listTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListTemplates<TData = Awaited<ReturnType<typeof listTemplates>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useListTemplates<TData = Awaited<ReturnType<typeof listTemplates>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListTemplatesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchListTemplatesQuery = async <TData = Awaited<ReturnType<typeof listTemplates>>, TError = unknown>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListTemplatesQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export type createTemplateResponse201 = {
  data: Template
  status: 201
}
    
export type createTemplateResponseSuccess = (createTemplateResponse201) & {
  headers: Headers;
};
;

export type createTemplateResponse = (createTemplateResponseSuccess)

export const getCreateTemplateUrl = () => {


  

  return `/api/v1/admin/templates`
}

export const createTemplate = async (templateInput: TemplateInput, options?: RequestInit): Promise<createTemplateResponse> => {
  
  return customFetch<createTemplateResponse>(getCreateTemplateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      templateInput,)
  }
);}




export const getCreateTemplateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTemplate>>, TError,{data: TemplateInput}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTemplate>>, TError,{data: TemplateInput}, TContext> => {

const mutationKey = ['createTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTemplate>>, {data: TemplateInput}> = (props) => {
          const {data} = props ?? {};

          return  createTemplate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof createTemplate>>>
    export type CreateTemplateMutationBody = TemplateInput
    export type CreateTemplateMutationError = unknown

    export const useCreateTemplate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTemplate>>, TError,{data: TemplateInput}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTemplate>>,
        TError,
        {data: TemplateInput},
        TContext
      > => {

      const mutationOptions = getCreateTemplateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type updateTemplateResponse200 = {
  data: Template
  status: 200
}
    
export type updateTemplateResponseSuccess = (updateTemplateResponse200) & {
  headers: Headers;
};
;

export type updateTemplateResponse = (updateTemplateResponseSuccess)

export const getUpdateTemplateUrl = (id: string,) => {


  

  return `/api/v1/admin/templates/${id}`
}

export const updateTemplate = async (id: string,
    templateInput: TemplateInput, options?: RequestInit): Promise<updateTemplateResponse> => {
  
  return customFetch<updateTemplateResponse>(getUpdateTemplateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      templateInput,)
  }
);}




export const getUpdateTemplateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTemplate>>, TError,{id: string;data: TemplateInput}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTemplate>>, TError,{id: string;data: TemplateInput}, TContext> => {

const mutationKey = ['updateTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTemplate>>, {id: string;data: TemplateInput}> = (props) => {
          const {id,data} = props ?? {};

          return  updateTemplate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof updateTemplate>>>
    export type UpdateTemplateMutationBody = TemplateInput
    export type UpdateTemplateMutationError = unknown

    export const useUpdateTemplate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTemplate>>, TError,{id: string;data: TemplateInput}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateTemplate>>,
        TError,
        {id: string;data: TemplateInput},
        TContext
      > => {

      const mutationOptions = getUpdateTemplateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type deleteTemplateResponse200 = {
  data: DeleteTemplate200
  status: 200
}
    
export type deleteTemplateResponseSuccess = (deleteTemplateResponse200) & {
  headers: Headers;
};
;

export type deleteTemplateResponse = (deleteTemplateResponseSuccess)

export const getDeleteTemplateUrl = (id: string,) => {


  

  return `/api/v1/admin/templates/${id}`
}

export const deleteTemplate = async (id: string, options?: RequestInit): Promise<deleteTemplateResponse> => {
  
  return customFetch<deleteTemplateResponse>(getDeleteTemplateUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getDeleteTemplateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTemplate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTemplate>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTemplate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteTemplate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTemplate>>>
    
    export type DeleteTemplateMutationError = unknown

    export const useDeleteTemplate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTemplate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTemplate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteTemplateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type listAdminInterviewsResponse200 = {
  data: ListAdminInterviews200
  status: 200
}
    
export type listAdminInterviewsResponseSuccess = (listAdminInterviewsResponse200) & {
  headers: Headers;
};
;

export type listAdminInterviewsResponse = (listAdminInterviewsResponseSuccess)

export const getListAdminInterviewsUrl = () => {


  

  return `/api/v1/admin/interviews`
}

export const listAdminInterviews = async ( options?: RequestInit): Promise<listAdminInterviewsResponse> => {
  
  return customFetch<listAdminInterviewsResponse>(getListAdminInterviewsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getListAdminInterviewsInfiniteQueryKey = () => {
    return [
    'infinite', `/api/v1/admin/interviews`
    ] as const;
    }

export const getListAdminInterviewsQueryKey = () => {
    return [
    `/api/v1/admin/interviews`
    ] as const;
    }

    
export const getListAdminInterviewsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listAdminInterviews>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listAdminInterviews>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminInterviewsInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminInterviews>>> = ({ signal }) => listAdminInterviews({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listAdminInterviews>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListAdminInterviewsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminInterviews>>>
export type ListAdminInterviewsInfiniteQueryError = unknown


export function useListAdminInterviewsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listAdminInterviews>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listAdminInterviews>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminInterviews>>,
          TError,
          Awaited<ReturnType<typeof listAdminInterviews>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListAdminInterviewsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listAdminInterviews>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listAdminInterviews>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminInterviews>>,
          TError,
          Awaited<ReturnType<typeof listAdminInterviews>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListAdminInterviewsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listAdminInterviews>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listAdminInterviews>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useListAdminInterviewsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listAdminInterviews>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listAdminInterviews>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListAdminInterviewsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchListAdminInterviewsInfiniteQuery = async <TData = Awaited<ReturnType<typeof listAdminInterviews>>, TError = unknown>(
 queryClient: QueryClient,  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listAdminInterviews>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListAdminInterviewsInfiniteQueryOptions(options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getListAdminInterviewsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminInterviews>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminInterviews>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminInterviewsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminInterviews>>> = ({ signal }) => listAdminInterviews({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminInterviews>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListAdminInterviewsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminInterviews>>>
export type ListAdminInterviewsQueryError = unknown


export function useListAdminInterviews<TData = Awaited<ReturnType<typeof listAdminInterviews>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminInterviews>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminInterviews>>,
          TError,
          Awaited<ReturnType<typeof listAdminInterviews>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListAdminInterviews<TData = Awaited<ReturnType<typeof listAdminInterviews>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminInterviews>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminInterviews>>,
          TError,
          Awaited<ReturnType<typeof listAdminInterviews>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListAdminInterviews<TData = Awaited<ReturnType<typeof listAdminInterviews>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminInterviews>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useListAdminInterviews<TData = Awaited<ReturnType<typeof listAdminInterviews>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminInterviews>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListAdminInterviewsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchListAdminInterviewsQuery = async <TData = Awaited<ReturnType<typeof listAdminInterviews>>, TError = unknown>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminInterviews>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getListAdminInterviewsQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export type getAdminInterviewDetailResponse200 = {
  data: AdminInterviewDetail
  status: 200
}

export type getAdminInterviewDetailResponse404 = {
  data: ErrorResponse
  status: 404
}
    
export type getAdminInterviewDetailResponseSuccess = (getAdminInterviewDetailResponse200) & {
  headers: Headers;
};
export type getAdminInterviewDetailResponseError = (getAdminInterviewDetailResponse404) & {
  headers: Headers;
};

export type getAdminInterviewDetailResponse = (getAdminInterviewDetailResponseSuccess | getAdminInterviewDetailResponseError)

export const getGetAdminInterviewDetailUrl = (id: string,) => {


  

  return `/api/v1/admin/interviews/${id}`
}

export const getAdminInterviewDetail = async (id: string, options?: RequestInit): Promise<getAdminInterviewDetailResponse> => {
  
  return customFetch<getAdminInterviewDetailResponse>(getGetAdminInterviewDetailUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminInterviewDetailInfiniteQueryKey = (id?: string,) => {
    return [
    'infinite', `/api/v1/admin/interviews/${id}`
    ] as const;
    }

export const getGetAdminInterviewDetailQueryKey = (id?: string,) => {
    return [
    `/api/v1/admin/interviews/${id}`
    ] as const;
    }

    
export const getGetAdminInterviewDetailInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAdminInterviewDetail>>>, TError = ErrorResponse>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminInterviewDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminInterviewDetailInfiniteQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminInterviewDetail>>> = ({ signal }) => getAdminInterviewDetail(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminInterviewDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAdminInterviewDetailInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminInterviewDetail>>>
export type GetAdminInterviewDetailInfiniteQueryError = ErrorResponse


export function useGetAdminInterviewDetailInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminInterviewDetail>>>, TError = ErrorResponse>(
 id: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminInterviewDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminInterviewDetail>>,
          TError,
          Awaited<ReturnType<typeof getAdminInterviewDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAdminInterviewDetailInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminInterviewDetail>>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminInterviewDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminInterviewDetail>>,
          TError,
          Awaited<ReturnType<typeof getAdminInterviewDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAdminInterviewDetailInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminInterviewDetail>>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminInterviewDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAdminInterviewDetailInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminInterviewDetail>>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminInterviewDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAdminInterviewDetailInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetAdminInterviewDetailInfiniteQuery = async <TData = Awaited<ReturnType<typeof getAdminInterviewDetail>>, TError = ErrorResponse>(
 queryClient: QueryClient, id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminInterviewDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetAdminInterviewDetailInfiniteQueryOptions(id,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetAdminInterviewDetailQueryOptions = <TData = Awaited<ReturnType<typeof getAdminInterviewDetail>>, TError = ErrorResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminInterviewDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminInterviewDetailQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminInterviewDetail>>> = ({ signal }) => getAdminInterviewDetail(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminInterviewDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAdminInterviewDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminInterviewDetail>>>
export type GetAdminInterviewDetailQueryError = ErrorResponse


export function useGetAdminInterviewDetail<TData = Awaited<ReturnType<typeof getAdminInterviewDetail>>, TError = ErrorResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminInterviewDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminInterviewDetail>>,
          TError,
          Awaited<ReturnType<typeof getAdminInterviewDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAdminInterviewDetail<TData = Awaited<ReturnType<typeof getAdminInterviewDetail>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminInterviewDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminInterviewDetail>>,
          TError,
          Awaited<ReturnType<typeof getAdminInterviewDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAdminInterviewDetail<TData = Awaited<ReturnType<typeof getAdminInterviewDetail>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminInterviewDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAdminInterviewDetail<TData = Awaited<ReturnType<typeof getAdminInterviewDetail>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminInterviewDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAdminInterviewDetailQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetAdminInterviewDetailQuery = async <TData = Awaited<ReturnType<typeof getAdminInterviewDetail>>, TError = ErrorResponse>(
 queryClient: QueryClient, id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminInterviewDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetAdminInterviewDetailQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export type requeueInterviewEvaluationResponse200 = {
  data: OkResponse
  status: 200
}
    
export type requeueInterviewEvaluationResponseSuccess = (requeueInterviewEvaluationResponse200) & {
  headers: Headers;
};
;

export type requeueInterviewEvaluationResponse = (requeueInterviewEvaluationResponseSuccess)

export const getRequeueInterviewEvaluationUrl = (id: string,) => {


  

  return `/api/v1/admin/interviews/${id}/requeue-evaluation`
}

export const requeueInterviewEvaluation = async (id: string, options?: RequestInit): Promise<requeueInterviewEvaluationResponse> => {
  
  return customFetch<requeueInterviewEvaluationResponse>(getRequeueInterviewEvaluationUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getRequeueInterviewEvaluationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requeueInterviewEvaluation>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requeueInterviewEvaluation>>, TError,{id: string}, TContext> => {

const mutationKey = ['requeueInterviewEvaluation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requeueInterviewEvaluation>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  requeueInterviewEvaluation(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RequeueInterviewEvaluationMutationResult = NonNullable<Awaited<ReturnType<typeof requeueInterviewEvaluation>>>
    
    export type RequeueInterviewEvaluationMutationError = unknown

    export const useRequeueInterviewEvaluation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requeueInterviewEvaluation>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requeueInterviewEvaluation>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getRequeueInterviewEvaluationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * 面談録音音声を取得する(operator のみ)。実体は GCS から取得しプロキシ配信。
 */
export type getAdminInterviewRecordingResponse200 = {
  data: Blob
  status: 200
}

export type getAdminInterviewRecordingResponse404 = {
  data: ErrorResponse
  status: 404
}
    
export type getAdminInterviewRecordingResponseSuccess = (getAdminInterviewRecordingResponse200) & {
  headers: Headers;
};
export type getAdminInterviewRecordingResponseError = (getAdminInterviewRecordingResponse404) & {
  headers: Headers;
};

export type getAdminInterviewRecordingResponse = (getAdminInterviewRecordingResponseSuccess | getAdminInterviewRecordingResponseError)

export const getGetAdminInterviewRecordingUrl = (id: string,) => {


  

  return `/api/v1/admin/interviews/${id}/recording`
}

export const getAdminInterviewRecording = async (id: string, options?: RequestInit): Promise<getAdminInterviewRecordingResponse> => {
  
  return customFetch<getAdminInterviewRecordingResponse>(getGetAdminInterviewRecordingUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminInterviewRecordingInfiniteQueryKey = (id?: string,) => {
    return [
    'infinite', `/api/v1/admin/interviews/${id}/recording`
    ] as const;
    }

export const getGetAdminInterviewRecordingQueryKey = (id?: string,) => {
    return [
    `/api/v1/admin/interviews/${id}/recording`
    ] as const;
    }

    
export const getGetAdminInterviewRecordingInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAdminInterviewRecording>>>, TError = ErrorResponse>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminInterviewRecording>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminInterviewRecordingInfiniteQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminInterviewRecording>>> = ({ signal }) => getAdminInterviewRecording(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminInterviewRecording>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAdminInterviewRecordingInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminInterviewRecording>>>
export type GetAdminInterviewRecordingInfiniteQueryError = ErrorResponse


export function useGetAdminInterviewRecordingInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminInterviewRecording>>>, TError = ErrorResponse>(
 id: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminInterviewRecording>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminInterviewRecording>>,
          TError,
          Awaited<ReturnType<typeof getAdminInterviewRecording>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAdminInterviewRecordingInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminInterviewRecording>>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminInterviewRecording>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminInterviewRecording>>,
          TError,
          Awaited<ReturnType<typeof getAdminInterviewRecording>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAdminInterviewRecordingInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminInterviewRecording>>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminInterviewRecording>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAdminInterviewRecordingInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminInterviewRecording>>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminInterviewRecording>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAdminInterviewRecordingInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetAdminInterviewRecordingInfiniteQuery = async <TData = Awaited<ReturnType<typeof getAdminInterviewRecording>>, TError = ErrorResponse>(
 queryClient: QueryClient, id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminInterviewRecording>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetAdminInterviewRecordingInfiniteQueryOptions(id,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetAdminInterviewRecordingQueryOptions = <TData = Awaited<ReturnType<typeof getAdminInterviewRecording>>, TError = ErrorResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminInterviewRecording>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminInterviewRecordingQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminInterviewRecording>>> = ({ signal }) => getAdminInterviewRecording(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminInterviewRecording>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAdminInterviewRecordingQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminInterviewRecording>>>
export type GetAdminInterviewRecordingQueryError = ErrorResponse


export function useGetAdminInterviewRecording<TData = Awaited<ReturnType<typeof getAdminInterviewRecording>>, TError = ErrorResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminInterviewRecording>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminInterviewRecording>>,
          TError,
          Awaited<ReturnType<typeof getAdminInterviewRecording>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAdminInterviewRecording<TData = Awaited<ReturnType<typeof getAdminInterviewRecording>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminInterviewRecording>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminInterviewRecording>>,
          TError,
          Awaited<ReturnType<typeof getAdminInterviewRecording>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAdminInterviewRecording<TData = Awaited<ReturnType<typeof getAdminInterviewRecording>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminInterviewRecording>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAdminInterviewRecording<TData = Awaited<ReturnType<typeof getAdminInterviewRecording>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminInterviewRecording>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAdminInterviewRecordingQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetAdminInterviewRecordingQuery = async <TData = Awaited<ReturnType<typeof getAdminInterviewRecording>>, TError = ErrorResponse>(
 queryClient: QueryClient, id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminInterviewRecording>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetAdminInterviewRecordingQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



/**
 * 面談評価レポート(PDF)を取得する(operator のみ)。実体は GCS から取得しプロキシ配信。レポートの有無は評価の reportGeneratedAt で判定する。
 */
export type getAdminInterviewReportResponse200 = {
  data: Blob
  status: 200
}

export type getAdminInterviewReportResponse404 = {
  data: ErrorResponse
  status: 404
}
    
export type getAdminInterviewReportResponseSuccess = (getAdminInterviewReportResponse200) & {
  headers: Headers;
};
export type getAdminInterviewReportResponseError = (getAdminInterviewReportResponse404) & {
  headers: Headers;
};

export type getAdminInterviewReportResponse = (getAdminInterviewReportResponseSuccess | getAdminInterviewReportResponseError)

export const getGetAdminInterviewReportUrl = (id: string,) => {


  

  return `/api/v1/admin/interviews/${id}/report`
}

export const getAdminInterviewReport = async (id: string, options?: RequestInit): Promise<getAdminInterviewReportResponse> => {
  
  return customFetch<getAdminInterviewReportResponse>(getGetAdminInterviewReportUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminInterviewReportInfiniteQueryKey = (id?: string,) => {
    return [
    'infinite', `/api/v1/admin/interviews/${id}/report`
    ] as const;
    }

export const getGetAdminInterviewReportQueryKey = (id?: string,) => {
    return [
    `/api/v1/admin/interviews/${id}/report`
    ] as const;
    }

    
export const getGetAdminInterviewReportInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAdminInterviewReport>>>, TError = ErrorResponse>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminInterviewReport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminInterviewReportInfiniteQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminInterviewReport>>> = ({ signal }) => getAdminInterviewReport(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminInterviewReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAdminInterviewReportInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminInterviewReport>>>
export type GetAdminInterviewReportInfiniteQueryError = ErrorResponse


export function useGetAdminInterviewReportInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminInterviewReport>>>, TError = ErrorResponse>(
 id: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminInterviewReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminInterviewReport>>,
          TError,
          Awaited<ReturnType<typeof getAdminInterviewReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAdminInterviewReportInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminInterviewReport>>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminInterviewReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminInterviewReport>>,
          TError,
          Awaited<ReturnType<typeof getAdminInterviewReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAdminInterviewReportInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminInterviewReport>>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminInterviewReport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAdminInterviewReportInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAdminInterviewReport>>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminInterviewReport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAdminInterviewReportInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetAdminInterviewReportInfiniteQuery = async <TData = Awaited<ReturnType<typeof getAdminInterviewReport>>, TError = ErrorResponse>(
 queryClient: QueryClient, id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAdminInterviewReport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetAdminInterviewReportInfiniteQueryOptions(id,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetAdminInterviewReportQueryOptions = <TData = Awaited<ReturnType<typeof getAdminInterviewReport>>, TError = ErrorResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminInterviewReport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminInterviewReportQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminInterviewReport>>> = ({ signal }) => getAdminInterviewReport(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminInterviewReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAdminInterviewReportQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminInterviewReport>>>
export type GetAdminInterviewReportQueryError = ErrorResponse


export function useGetAdminInterviewReport<TData = Awaited<ReturnType<typeof getAdminInterviewReport>>, TError = ErrorResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminInterviewReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminInterviewReport>>,
          TError,
          Awaited<ReturnType<typeof getAdminInterviewReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAdminInterviewReport<TData = Awaited<ReturnType<typeof getAdminInterviewReport>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminInterviewReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminInterviewReport>>,
          TError,
          Awaited<ReturnType<typeof getAdminInterviewReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAdminInterviewReport<TData = Awaited<ReturnType<typeof getAdminInterviewReport>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminInterviewReport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAdminInterviewReport<TData = Awaited<ReturnType<typeof getAdminInterviewReport>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminInterviewReport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAdminInterviewReportQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetAdminInterviewReportQuery = async <TData = Awaited<ReturnType<typeof getAdminInterviewReport>>, TError = ErrorResponse>(
 queryClient: QueryClient, id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminInterviewReport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetAdminInterviewReportQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



